import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  translate as t,
  Filter,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import PlaceSelector from '../components/inputs/PlaceSelector';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';

const BookingUserFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="$regex" alwaysOn />
  </Filter>
);

export const BookingUserList = (props) => (
  <List {...props} perPage={20} filters={<BookingUserFilter />}>
    <Datagrid>
      <TextField source="objectId" />
      <TextField source="username" />
      <EditButton {...props} basePath="/booking-users" />
      <DeleteButton {...props} basePath="/booking-users" />
    </Datagrid>
  </List>
);

// eslint-disable-next-line no-shadow
const BookingUserTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.username }) : ''}</span>
));

export const BookingUserEdit = (props) => (
  <Edit title={<BookingUserTitle />} {...props}>
    <SimpleForm {...props} autocomplete="off">
      <TextInput source="username" autocomplete="off" options={{ autoComplete: 'edit-username' }} />
      <TextInput type="password" source="password" options={{ autoComplete: 'edit-password' }} />
      <PlaceSelector source="placeId" />
    </SimpleForm>
  </Edit>
);

export const BookingUserCreate = (props) => (
  <Create {...props}>
    <SimpleForm {...props}>
      <TextInput source="username" options={{ autoComplete: 'new-username' }} />
      <TextInput type="password" source="password" options={{ autoComplete: 'new-password' }} />
      <PlaceSelector source="placeId" />
    </SimpleForm>
  </Create>
);
